import { dataProps } from './properties'

export const setHandloomClusterList = (state, payload) => {
    state.list = payload
}    

export const setHandloomClusterData = (state, payload) => {
    state.props = payload
} 

export const resetHandloomClusterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/handloomCluster/mutations.js